import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { ButtonTheme } from '@rd/types';

@Component({
  selector: 'rd-tcv2-membership-success-dialog',
  templateUrl: './membership-success-dialog.component.html',
  styleUrls: ['./membership-success-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2MembershipSuccessDialogComponent implements OnInit {
  @HostBinding('class.rd-tcv2-membership-success-dialog') componentClass = true;

  // @ts-ignore
  loyaltyProgramShortName: string =
    // @ts-ignore
    this.dialogConfig.data.loyaltyProgramShortName;

  constructor(
    private dialogConfig: DialogConfig<{ loyaltyProgramShortName?: string }>,
    private dialogRef: DialogRef,
    private iconRegistryService: IconRegistryService,
    private popupSettingService: PopupSettingService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('linked');
  }

  get buttonTheme(): ButtonTheme {
    return this.popupSettingService.singleButtonTheme;
  }
}
